import script from "./delivery-service-detail-v1.vue?vue&type=script&lang=ts&setup=true"
export * from "./delivery-service-detail-v1.vue?vue&type=script&lang=ts&setup=true"

import "./delivery-service-detail-v1.vue?vue&type=style&index=0&id=5d7a797d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7a797d"]])

export default __exports__